const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/live_streams/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { queryParamsSchema } from "@circle-react/components/SettingsApp/LiveStreamSettings/hooks/useFilterParams";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/live_streams")({
  validateSearch: queryParamsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});